export const TextArr = ["Yes, my package is not ready yet", "Yes, I change my plans", "Yes, I entered wrong information", "Yes, I want to change my pick-up time"]

export interface ComponentInterface {
  loading: boolean;
  selected: string;
  toastMessage: string;
  resetToastMessage: () => void;
  setSelected: (args: string) => void;
  cancelPickupHandler: () => void;
  onBack: () => void;
}